import utility from "../../../helpers/paymentHelpers/utility";

export default {
  namespaced: true,
  state: {
    allNetBankingBanks: [],
    isNetBankingModalOpen: false,
    placeOrderButtonColorGray: true
  },
  getters: {},
  mutations: {
    updatePlaceOrderButtonColorGray(state, payload){
      state.placeOrderButtonColorGray = payload;
    },
    updateNetBankingModal(state, payload){
      state.isNetBankingModalOpen = payload;
      payload ? document.body.classList.add("body-stop-scroll-mobile") : 
      document.body.classList.remove("body-stop-scroll-mobile");
    },
    updateAllNetBankingBanks(state, payload) {
      let data = utility.deepCopyArry(payload) || [];
      state.allNetBankingBanks = data.map((i) => i.subOptions).flat() || [];
    },
  },
  actions: {},
};
